import React from 'react';
import { FacebookIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 py-12 px-4 sm:px-6 lg:px-8" data-id="element-64">
      <div className="max-w-7xl mx-auto" data-id="element-65">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-66">
          {/* Brand */}
          <div data-id="element-67">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xA4VGCog93ZhVvQk6fCtDZ/logo-web.png" alt="ArrendaLogic" className="h-10 w-auto mb-4 brightness-0 invert" data-id="element-68" />
            <p className="text-sm text-slate-400 mb-4" data-id="element-69">
              Soluciones de arrendamiento puro para empresas y profesionistas en
              México.
            </p>
            <div className="flex gap-3" data-id="element-70">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-primary transition-colors" data-id="element-71">
                <FacebookIcon className="w-5 h-5" data-id="element-72" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-primary transition-colors" data-id="element-73">
                <LinkedinIcon className="w-5 h-5" data-id="element-74" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-primary transition-colors" data-id="element-75">
                <InstagramIcon className="w-5 h-5" data-id="element-76" />
              </a>
            </div>
          </div>

          {/* Solutions */}
          <div data-id="element-77">
            <h4 className="font-semibold text-white mb-4" data-id="element-78">Soluciones</h4>
            <ul className="space-y-2 text-sm" data-id="element-79">
              <li data-id="element-80">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-81">
                  Arrendamiento Puro
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-83">
                  Sale & Lease Back
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-85">
                  Autos y Flotillas
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-87">
                  Maquinaria
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-89">
                  Equipo de Cómputo
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-90">
            <h4 className="font-semibold text-white mb-4" data-id="element-91">Empresa</h4>
            <ul className="space-y-2 text-sm" data-id="element-92">
              <li data-id="element-93">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-94">
                  Acerca de
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-96">
                  Blog
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-98">
                  Casos de éxito
                </a>
              </li>
              <li data-id="element-99">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-100">
                  Trabaja con nosotros
                </a>
              </li>
              <li data-id="element-101">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-102">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-103">
            <h4 className="font-semibold text-white mb-4" data-id="element-104">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-105">
              <li data-id="element-106">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-107">
                  Términos y condiciones
                </a>
              </li>
              <li data-id="element-108">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-109">
                  Aviso de privacidad
                </a>
              </li>
              <li data-id="element-110">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-111">
                  Políticas de crédito
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-112">
          <p className="text-sm text-slate-400" data-id="element-113">
            © 2025 ArrendaLogic. Todos los derechos reservados.
          </p>
          <p className="text-xs text-slate-500" data-id="element-114">
            Diseñado para empresas mexicanas que buscan crecer
          </p>
        </div>
      </div>
    </footer>;
}